import axios from "axios";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Table } from "reactstrap";
import { ServiceThreadSpinner } from ".";
import { useGetItemClasses } from '../hooks';
import { api, helpers } from "../utils";

export default function InventoryDashBoardSalesActivityGrid(props) {
   const {
      selectedItem,
      getAll,
      typeOfDataSource,
      salesActivitySortDireciton,
      salesActivitySortField,
   } = props.params;

   const classList = useGetItemClasses();
   const [data, setData] = useState([]);
   const [loaded, setLoaded] = useState(false);
   const [params, setParams] = useState({});
   const payload = {
      ItemNumber: selectedItem?.value,
      GetAll: getAll,
      TypeOfSource: typeOfDataSource,
      SalesActivitySortDireciton: salesActivitySortDireciton,
      SalesActivitySortField: salesActivitySortField,
      ClassList: classList.list
   }

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      if (props.params.selectedItem?.value !== params.selectedItem?.value) {
         setParams(props.params)
         setLoaded(false); //for the spinner
      }

      if (!classList.list.length) return;
      api
         .postS('Inventory/SalesActivity', payload, source.token)
         .then(response => {
            if (response.data.success) {
               const dataResponse = response.data.itemGrid.salesActivity
               setData(dataResponse);
               //set total here if its there
            } else {
               throw new Error(response);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setLoaded(true));

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.params, classList])

   let alreadyDisplayedList = [];
   return (
      <>
         <Card className="dashboard-card">
            <CardBody>
               <div>
                  <span className="h2 me-2">Sales Activity Last 12 Months</span>
               </div>
               <hr />
               <ServiceThreadSpinner on={!loaded}>
                  {loaded && data.length !== 0 ?
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th>Avg Usage</th>
                              <th>Sales Avg</th>
                              <th>Total Sold</th>
                              <th>Total Sales</th>
                              <th>On Hand</th>
                              <th>Sales Period</th>
                              <th>Monthly Qty</th>
                              <th>Monthly Sales</th>
                              <th>Avg Price/Lb</th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(data, (datum, index) => {
                              const alreadyDisplayed = !_.includes(
                                 alreadyDisplayedList,
                                 datum.itemNumber
                              );
                              alreadyDisplayedList.push(datum.itemNumber);
                              return (
                                 <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                                    {alreadyDisplayed ? (
                                       <td className="data-cell" children={Math.round(datum.monthlyUsageAverage).toLocaleString()} />
                                    ) : (
                                       <td>{""}</td>
                                    )}

                                    {alreadyDisplayed ? (
                                       <td className="data-cell" children={helpers.formatCurrency(datum.monthlySalesAverage)} />
                                    ) : (
                                       <td>{""}</td>
                                    )}

                                    {alreadyDisplayed ? (
                                       <td className="data-cell" children={Math.round(datum.itemGroupTotalQuantity).toLocaleString()} />
                                    ) : (
                                       <td>{""}</td>
                                    )}

                                    {alreadyDisplayed ? (
                                       <td className="data-cell" children={helpers.formatCurrency(datum.itemGroupTotalSales)} />
                                    ) : (
                                       <td>{""}</td>
                                    )}

                                    {alreadyDisplayed ? (
                                       <td className="data-cell" children={Math.round(datum.quantityOnHand).toLocaleString()} />
                                    ) : (
                                       <td>{""}</td>
                                    )}

                                    <td className="data-cell" children={datum.monthYearDescription} />
                                    <td className="data-cell" children={Math.round(datum.monthlyQuantity).toLocaleString()} />
                                    <td className="data-cell" children={helpers.formatCurrency(datum.monthlySales)} />
                                    <td className="data-cell" children={helpers.formatCurrency(datum.monthlyAvgPrice)} />
                                 </tr>
                              );
                           })}
                        </tbody>
                     </Table>
                     :
                     <div>
                        <span>No sales activity found for the period</span>
                     </div>
                  }
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </>
   );
}
